// extracted by mini-css-extract-plugin
export var adv = "style-module--adv--707e3";
export var left = "style-module--left--ac1e0";
export var right = "style-module--right--05186";
export var wrap = "style-module--wrap--11adf";